import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { Skeleton } from '@/components/ui/skeleton';

interface PlatformAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Gate for the internal /admin area. Requires an authenticated user whose
 * `is_platform_admin` flag is set (from GET /me). Non-admins are bounced to the
 * dashboard. This is cosmetic only: the backend enforces 403 on /api/platform/*.
 */
export function PlatformAdminRoute({ children }: PlatformAdminRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="space-y-4 w-96">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-full" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  if (!user?.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
